import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const ApiIATokenKey = 'ApiIA-Token'

const canUseLocalStorage = () => typeof window !== 'undefined' && window.localStorage

export function getToken () {
  return Cookies.get(TokenKey)
}

export function setToken (token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken () {
  return Cookies.remove(TokenKey)
}

export function getApiIAToken () {
  if (!canUseLocalStorage()) return null
  return window.localStorage.getItem(ApiIATokenKey)
}

export function setApiIAToken (token) {
  if (!canUseLocalStorage()) return
  if (token) {
    window.localStorage.setItem(ApiIATokenKey, token)
  } else {
    window.localStorage.removeItem(ApiIATokenKey)
  }
}

export function removeApiIAToken () {
  if (!canUseLocalStorage()) return
  window.localStorage.removeItem(ApiIATokenKey)
}
